import { Text } from '@soteria/design-system-ve';

// Constants for calculations
const SECONDS_PER_MONTH = 30 * 24 * 60 * 60; // 30 days * 24 hours * 60 minutes * 60 seconds

// Default values in case API doesn't return them
const DEFAULT_COST_PER_AUDIO_HOUR = 0.014;
const DEFAULT_CLIPS_PER_HOUR = 240; // 60 minutes * 60 seconds / 15 seconds per clip
const DEFAULT_MONTHLY_BUDGET = 5000;

interface BillingEstimateProps {
  monthlyBudget?: number;
  costPerAudioHour?: number;
  clipsPerHour?: number;
  className?: string;
}

/**
 * Component for displaying billing estimates based on monthly budget and rates
 * Handles default values if the API doesn't return them
 */
export function BillingEstimate({
  monthlyBudget = DEFAULT_MONTHLY_BUDGET,
  costPerAudioHour = DEFAULT_COST_PER_AUDIO_HOUR,
  clipsPerHour = DEFAULT_CLIPS_PER_HOUR,
  className,
}: BillingEstimateProps) {
  if (monthlyBudget <= 0 || costPerAudioHour <= 0) {
    return null;
  }

  // Calculate estimated values
  const estimatedRPS = Math.round(((monthlyBudget / costPerAudioHour) * clipsPerHour) / SECONDS_PER_MONTH);
  const estimatedAudioHours = Math.round(monthlyBudget / costPerAudioHour);

  return (
    <div className={className} style={{ marginTop: className ? 0 : '16px' }}>
      <Text style={{ fontSize: '12px', fontStyle: 'italic' }}>
        Estimated {estimatedAudioHours.toLocaleString()} audio hours per month, estimated {estimatedRPS.toLocaleString()} RPS
      </Text>
    </div>
  );
}

export default BillingEstimate;
